<fadv-card>
    <fadv-card-header>
      <div class="card-header-formatting">
        <fadv-typography style="text-align: center" type="heading-small" variant="white">
          Partner Email
        </fadv-typography>
        <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
      </div>
    </fadv-card-header>
<form [formGroup]="emailForm" (ngSubmit)="onSubmit()">
    <fadv-card-body>
        <fadv-grid>
            <fadv-grid-row>
                <fadv-grid-col>
                    <fadv-input formControlName="partnerID" type="text" label="Enter ID"></fadv-input>
                </fadv-grid-col>
            </fadv-grid-row>
            <fadv-grid-row>
                <fadv-grid-col alignment="center">
                  <fadv-box pt="xxx-large" pb="large">
                    <fadv-button style="width:200px;" size="medium" variant="primary"
                      [disabled]="this?.emailForm?.invalid" (click)="onSubmit()" type="button"
                      name="partner-email-next-button">
                      Next
                    </fadv-button>
                  </fadv-box>
                </fadv-grid-col>
              </fadv-grid-row>
        </fadv-grid>
    </fadv-card-body>
</form>
</fadv-card>
